// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".core-container[data-v-5316702b]{margin-left:auto;margin-right:auto;max-width:360px;min-width:360px;width:100%;display:flex;flex-direction:column;align-items:center}@media(min-width:1052px){.core-container[data-v-5316702b]{max-width:1052px;min-width:1052px}}", ""]);
// Exports
module.exports = exports;
